export const language: any = {
  title: "सामग्री",
  select_all: "सभी चुनें",
  deselect_all: "सभी चयन हटाएं",
  add: "सामग्री जोड़ें",
  add_title: "कृपया चुनें कि सामग्री कैसे जोड़नी है।",
  add_by_list: "सामग्री जोड़ें",
  add_total: "कुल {number} सामग्री जोड़ें",
  selecting: "कुल सामग्री",
  filter_title: "चयन को छांटें",
  filter_newest: "नवीनतम",
  filter_oldest: "सबसे पुराना",
  filter_alphabet: "वर्णानुक्रम में",
  get_recipe: "एआई कुकिंग सिफारिशें प्राप्त करें",
  search_placeholder: "कृपया अपना खोज शब्द दर्ज करें।",
  nodata: "कोई सामग्री उपलब्ध नहीं है।",
  request: "सामग्री जोड़ें",
  recipe_title: "सुझाए गए व्यंजन",
  option: {
    title: "विकल्प चुनें",
    desc: "विकल्प चुनना आवश्यक नहीं है।",
    complete: "पूरा करें",
    reset: "रीसेट करें"
  },
  msg: {
    msg_7: "क्या आप चयनित सामग्री जोड़ना चाहेंगे?",
    msg_8: `
      <p>क्या आप चयनित सामग्री जोड़ना चाहेंगे?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> को छोड़ दिया गया है क्योंकि वे पहले से ही मौजूदा सामग्री में शामिल हैं।)</p>
    `,
    msg_9: "क्या आप चयनित सामग्री को अपने शॉपिंग कार्ट में जोड़ना चाहेंगे?",
    msg_10: `
      <p>क्या आप चयनित सामग्री को अपने शॉपिंग कार्ट में जोड़ना चाहेंगे?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> को छोड़ दिया गया है क्योंकि वे पहले से ही मौजूदा सामग्री में शामिल हैं।)</p>
    `,
    confirm: "जोड़ें",
    cancel: "रद्द करें",
    not_ingredient: "ऐसा लगता है कि आपने जो दर्ज किया है वह कोई खाना पकाने की सामग्री नहीं है।<br />कृपया पुनः जाँच करें।",
    ai_failed: "सामग्री दर्ज करते समय एक त्रुटि हुई।<br />कृपया बाद में पुनः प्रयास करें।",
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> को छोड़ दिया गया है क्योंकि वे पहले से ही मौजूदा सामग्री में शामिल हैं।)`
  },
  history: "छवि विश्लेषण इतिहास",
  myIngredient: "मेरी सामग्री",
  history_no_data: "कोई इतिहास उपलब्ध नहीं है",
  history_take_photo: "फोटो लें या चुनें"
}
